"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var Routes_1 = require("../../constants/Routes");
var loginSlice_1 = require("../../features/login/loginSlice");
var useDeviceResize_1 = require("../../hooks/useDeviceResize");
var logo_svg_1 = __importDefault(require("../../../images/logo.svg"));
var logo_home_svg_1 = __importDefault(require("../../../images/logo_home.svg"));
var Logo = function (_a) {
    var currentLanguage = _a.currentLanguage;
    var _b = react_1.useState(0), scrollPosition = _b[0], setScrollPosition = _b[1];
    var history = react_router_dom_1.useHistory();
    var location = react_router_dom_1.useLocation();
    var dispatch = react_redux_1.useDispatch();
    var mobileResize = useDeviceResize_1.useDeviceResize(useDeviceResize_1.MediaQueries.mobile);
    var redirectToHomePage = function (event) {
        event.preventDefault();
        history.push(Routes_1.Routes.Home.path);
        dispatch(loginSlice_1.closeLoginFormModal());
    };
    var handleScroll = function () {
        setScrollPosition(window.pageYOffset);
    };
    react_1.useEffect(function () {
        window.addEventListener('scroll', handleScroll);
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (react_1.default.createElement(react_router_dom_1.Link, { to: "/", onClick: redirectToHomePage },
        react_1.default.createElement("img", { className: "logo", 
            // TODO: need to refactor src statement when logo will be identical for both hy and ru languages
            src: !mobileResize &&
                location.pathname === '/' &&
                scrollPosition === 0
                ? logo_home_svg_1.default
                : logo_svg_1.default, alt: "Banali", title: "banali", onClick: function () {
                window.scrollTo(0, 0);
            } })));
};
exports.default = react_1.memo(Logo);
